<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/wPtUQ8/tc-custom/9781479871834.jpg?1728327144618" alt="This image is the cover for the book What Works for Women at Work"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">What Works for Women at Work
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Up-beat, pragmatic, and chock full of advice, What Works for Women at Work is an indispensable guide for working women.</b><br/><br/> An essential resource for any working woman, What Works for Women at Work is a comprehensive and insightful guide for mastering office politics as a woman. Authored by Joan C. Williams, one of the nation’s most-cited experts on women and work, and her daughter, writer Rachel Dempsey, this unique book offers a multi-generational perspective into the realities of today’s workplace. Often women receive messages that they have only themselves to blame for failing to get ahead—Negotiate more! Stop being such a wimp! Stop being such a witch! What Works for Women at Work tells women it’s not their fault. The simple fact is that office politics often benefits men over women.        Based on interviews with 127 successful working women, over half of them women of color, What Works for Women at Work presents a toolkit for getting ahead in today’s workplace. Distilling over 35 years of research, Williams and Dempsey offer four crisp patterns that affect working women:  Prove-It-Again!, the Tightrope, the Maternal Wall, and the Tug of War. Each represents different challenges and requires different strategies—which is why women need to be savvier than men to survive and thrive in high-powered careers. Williams and Dempsey’s analysis of working women is nuanced and in-depth, going far beyond the traditional cookie-cutter, one-size-fits-all approaches of most career guides for women. Throughout the book, they weave real-life anecdotes from the women they interviewed, along with quick kernels of advice like a “New Girl Action Plan,” ways to “Take Care of Yourself”, and even “Comeback Lines” for dealing with sexual harassment and other difficult situations.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Joan C. Williams, Rachel Dempsey, Anne-Marie Slaughter
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      New York University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?dc45c0bc